<div class="table">
  <table fixedcols="[0, 3, 6]" id="servicelog_settings">
    <tr>
      <th>{{'Date'|translate}}</th>
      <th>{{'Value'|translate}}</th>
      <th> <button class="btn_img btn_graygray btn_plusorange" (click)="openAdd()"></button></th>
    </tr>
    <tr *ngFor="let log of Object.ServiceLogs">
      <td class="date_column">
        <calendar [name]="log.Id?.toString() ?? 'current'" [(date)]="log.Date" />
      </td>
      <td>
        <input *ngIf="currentItem == getIndex(log)" type="text" [(ngModel)]="log.Value"/>
        <span *ngIf="currentItem !== getIndex(log)">{{ log.Value }}</span>
      </td>
      <td>
        <button *ngIf="currentItem != getIndex(log)" (click)="currentItem = getIndex(log)" class="btn_img btn_edit"></button>
        <button *ngIf="currentItem == getIndex(log)" (click)="currentItem = undefined" class="btn_img btn_tick"></button>
        <button (click)="deleteLog(log)" class="btn_img btn_remove"></button>
      </td>
    </tr>
  </table>
</div>
